var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.987 30H5c2.847-.6 3.559-1.998 3.559-2.622.06-6.743.148-20.733-.001-22.756C8.408 2.6 6.123 2.032 4.999 2h22.475v6.274c-.75-1.31-2.585-4.045-3.933-4.495-1.686-.563-8.054-.563-8.99 0-.75.449-1.186 1.248-1.311 1.591v21.54c.063.28.32.992.844 1.592S16.237 29.75 16.987 30z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForth);
export default __webpack_public_path__ + "static/media/FORTH.a4a486f8b2dae3e2504a5a575dcbd22b.svg";
export { ForwardRef as ReactComponent };